import { CwtApiSchema, CwtProp, CwtSchema } from '@cawita/core-front/api';

@CwtSchema()
export class Address extends CwtApiSchema {
    @CwtProp() line1?: string;
    @CwtProp() line2?: string;
    @CwtProp() city?: string;
    @CwtProp() zip?: string;
    @CwtProp() country?: string;
}